
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-120 -80 240 160"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M-1 55.426h2V-38c2-2 2-5 2-8 0-2 0-10-3-18.663C-3-56-3-48-3-46c0 3 0 6 2 8z","stroke-miterlimit":"10","transform":"rotate(30)"}})]),_c('path',{attrs:{"fill":"#fff","d":"M-120-80h240V80h-240z"}}),_c('path',{attrs:{"d":"M-120-80h240v48h-240z"}}),_c('path',{attrs:{"fill":"#060","d":"M-120 32h240v48h-240z"}}),_c('g',{attrs:{"id":"b"}},[_c('use',{attrs:{"xlink:href":"#a","stroke":"#000"}}),_c('use',{attrs:{"xlink:href":"#a","fill":"#fff"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"scale(-1 1)"}}),_c('path',{attrs:{"fill":"#b00","d":"M-120-24v48h101c3 8 13 24 19 24s16-16 19-24h101v-48H19C16-32 6-48 0-48s-16 16-19 24z"}}),_c('path',{attrs:{"id":"c","d":"M19 24c3-8 5-16 5-24s-2-16-5-24c-3 8-5 16-5 24s2 16 5 24"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"scale(-1 1)"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('ellipse',{attrs:{"rx":"4","ry":"6"}}),_c('path',{attrs:{"id":"d","d":"M1 5.85s4 8 4 21-4 21-4 21z"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"scale(-1)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"scale(-1 1)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"scale(1 -1)"}})])])
          )
        }
      }
    